import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=dc1e1a8a&shadow"
import script from "./Button.vue?vue&type=script&lang=js&shadow"
export * from "./Button.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports